import { Routes } from "akademika/akamont/constants/Routes";
import BaseController from "../sharedControllers/BaseController";
import {
  GetAuditLogLevelTranslationKey,
  GetStateForAuditLogLevel,
} from "akademika/akamont/utils/AuditLogLevelUtil";

/**
 * @namespace akademika.akamont.pages.logDetails
 */
export default class LogDetails extends BaseController {
  route = Routes.LOG_DETAILS;
  parentRoute = Routes.LOG_LIST;

  public async onRouteMatched() {
    await this.fetchModel(
      `api/AuditLog/GetAuditLogDetails/${this.routeParams.auditLogId}`
    );
  }

  public getAuditLogLevelTranslation(logLevel: number) {
    const key = GetAuditLogLevelTranslationKey(logLevel);
    return this.translate(key);
  }

  public getStateForAuditLogLevel = GetStateForAuditLogLevel;
}
